import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { Campaign } from "./pages/Campaign";
import "./styles.css";
import { CodeScanner } from "./pages/CodeScanner";
import './i18n';

export function App () {
  return (
    <div>
      <Router>
        <Routes>
          <Route exact path="/" element={ <CodeScanner /> } />
          <Route path="/:uuid" element={ <Campaign />} />
          <Route path="/:uuid/stand/:stand" element={ <Campaign />} />
          <Route path="*" element={ <Navigate to="/" /> } />
        </Routes>
      </Router>
    </div>
  );
}
